import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import * as colors from "../../util/colors";
import { UnderlineTransition, UnderlineTransitionHover } from "../../util/typography/Text";
import { useSelector } from 'react-redux';

const ButtonWarpper = styled.div`
  display: flex;
  justify-content: flex-end;
  cursor: default;
  max-width: 992px;
  margin-inline: auto;
  pointer-events: none !important;
  height: 70px;

  @media (max-width: 993px) and (min-width: 790px) {
    padding-right: 20px;
  }
  @media (max-width: 790px){
    padding-right: 10px;
  }
`;
const Button = styled.button`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  gap: 5px;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  color: ${colors.white};
  background-image: linear-gradient(to bottom, ${colors.blueberryDark} 0%, ${colors.blueberryDark} 50%, ${colors.blueberry} calc(50% + 1px), ${colors.blueberry} 100%);
  background-position: center bottom;
  background-size: 100% 210%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.35);
  pointer-events: auto !important;
  font-family: proxima-nova;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  line-height: normal;
  transition: background 0.3s, opacity 0.3s, visibility 0.3s, position 0.3s, transform 0.3s ease-in-out;
  opacity: 0;
  visibility: hidden;
  z-index: 9;
  overflow:hidden;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  position: fixed;
  bottom: 0;
  // transform: translate(0%, -238%);

  span {
    position: relative;

    &::after {
        ${UnderlineTransition};
        }   
  }
  &.show {
      opacity: 1;
      visibility: visible;
  }

  @media (max-width: 790px){
    @keyframes slideUpMobile {
      from {
        transform: translateY(0);
      }
      to {
        transform: translateY(-14px);
      }
    }     

    &.footer-stick {
    animation: slideUpMobile 0.6s ease-out forwards;
    }

    @keyframes slideDownMobile {
      from {
        transform: translateY(-14px);
      }
      to {
        transform: translateY(0);
      }
    } 
        
    &.footer-stick-down {
      animation: slideDownMobile 0.6s ease-out forwards;
    }
  }

  .arrow-icon {
    // background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none"><path d="M17.1429 8.57143L10 1.42857L2.85717 8.57143" stroke="white" stroke-width="2"/></svg>');
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.2138 8L13.6069 6.60691L7 0L0.393089 6.60691L1.78618 8L7 2.78695L12.2138 8Z" fill="white"/></svg>');
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 100%;
    width: 13.214px;
    height: 8px;
    flex-shrink: 0;
  }

&:hover,
&:active {
    color: ${colors.white};
    background-position: center top;
    .arrow-icon {
      animation-duration: 0.3s;
      animation-name: back-top-slide-up;
      animation-fill-mode: both;
    }
    span::after{
      ${UnderlineTransitionHover}
    }
  }

  @keyframes back-top-slide-up {
    0% {
      background-position: center 100%;
    }
    50% {
      background-position: center calc(0% - 10px);
    }
    50.001% {
      background-position: center calc(100% + 10px);
    }
    100% {
      background-position: center 100%;
    }
  }
`;
const BackToTop = () => {
  let IsiScroll = useSelector(state => state.scrolledPastInPageSSI);
  let innerWidthRef = useRef(null);

  useEffect(() => {
    
    function handleShow() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const remainingScroll = scrollHeight - scrollTop - clientHeight;

      // const footerPartialClass = 'FooterLegal__FooterWrapper'; 
      const footerPartialClass = 'FooterNavigation__FooterContainer';

      const matchingElements = Array.from(document.querySelectorAll('*')).filter(el => {
        if (!el.classList) return false;
          return Array.from(el.classList).some(cls =>
          cls.toLowerCase().includes(footerPartialClass.toLowerCase())
        );
      });

      if (matchingElements.length > 0) {
        const utilityFooter = matchingElements[matchingElements.length - 1].getBoundingClientRect(); 

        if (window.scrollY > 300) {
          document.getElementById("back-to-top").classList.add("show");
        } else {
          document.getElementById("back-to-top").classList.remove("show");
          if(document.getElementById("back-to-top").style.display=="none"){
            document.getElementById("back-to-top").style.display="flex";
          }
        }

        if(window.innerWidth > 789){
          if(remainingScroll <= (utilityFooter.height)){
            document.getElementById("back-to-top").style.position= 'sticky';
          }
          else {
              document.getElementById("back-to-top").style.position= 'fixed';        
          }           
        }

        if(window.innerWidth < 790){
          document.getElementById("back-to-top").style.position= 'fixed';
          document.getElementById("back-to-top").classList.remove("footer-stick-down")
          if(remainingScroll < 200){
            document.getElementById("back-to-top").classList.add("footer-stick")
            document.getElementById("back-to-top").classList.remove("footer-stick-down")

            if(document.querySelector('.headroom').classList.contains('headroom--pinned')){
              document.getElementById("back-to-top").classList.add("footer-stick-down")
              document.getElementById("back-to-top").classList.remove("footer-stick")
            }
          }         
          
        }           
      }
    }
    handleShow();
    window.addEventListener("scroll", handleShow);
    return () => {
      window.removeEventListener("scroll", handleShow);
    };
  }, []);

  useEffect(() => {
    let timeoutId;

    function handleISI (){
      innerWidthRef.current = window.innerWidth;
        if (IsiScroll) {
        document.getElementById("back-to-top").style.transform = "translateY(0px)";
        } else {
          if(window.innerWidth < 770){
            document.getElementById("back-to-top").style.transform = "translateY(-384%)";
          }
          else {
            document.getElementById("back-to-top").style.transform = "translateY(-301%)";
          }
          
          if (window.scrollY < 300) {
          document.getElementById("back-to-top").style.display="flex";
          }
        }
      }

  function handleResize(){
    clearTimeout(timeoutId)
    timeoutId = setTimeout(()=>{ handleISI()}, 1000)
  }
 
  handleISI();
  window.addEventListener("resize", handleResize);

  return () => {
    clearTimeout(timeoutId);
    window.removeEventListener("resize", handleResize);
  };
}, [IsiScroll]);


  function handleTop(eve) {
    eve.preventDefault();
    document.getElementById("back-to-top").style.display="none";
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  return (
<ButtonWarpper>
<Button
        id="back-to-top"
        onClick={(eve) => {
          handleTop(eve);
        }}
>
<i className="arrow-icon"></i>
<span>Top</span>
</Button>
</ButtonWarpper>
  );
};
export default BackToTop;